import {BaseObject} from './BaseObject';

export class DocumentCurrency extends BaseObject {
    id: number;
    name: string;
    slug: string;
    symbol: string;
}



// WEBPACK FOOTER //
// /app/src/model/Entities/DocumentCurrency.ts